import './settings-leaf.css';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * The way in to the checklist library from Settings.
 *
 * The library is its own page — sections, bilingual tasks and visit rules
 * need the room — and until now the only door to it was on a property's
 * checklist, so an office that had not opened one yet could not find it.
 * Like the API reference card, this is the door, not the room.
 */
export default function ChecklistLibraryCard() {
  const { t } = useTranslation();

  return (
    <section className="card work-section settings-leaf mb-6" aria-labelledby="checklist-library-heading">
      <div className="work-section-heading">
        <h2 id="checklist-library-heading" className="mb-4 text-lg font-semibold">
          {t('checklistStack.library')}
        </h2>
      </div>
      <p className="mb-4 text-sm text-[color:var(--color-muted)]">{t('checklistStack.settingsHint')}</p>
      <Link className="btn btn-primary" to="/checklist-templates">
        {t('checklistStack.openLibrary')}
      </Link>
    </section>
  );
}
